import React from 'react'
import { Button } from 'react-bootstrap'
import { getNumericValidator } from '../../../Forms/fieldValidators'
import CamposPesado0 from './CamposPesado0'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_PESO_DESTARE } from '../../../../config/forms'

const numeric12 = getNumericValidator(9, 12)

function PesadoDestareBalanzaManual (props) {
  const { onBlurInput, setStepPesadoManual, reset } = props

  const label = 'Número de CTG'
  const validate = [numeric12]

  const handleSubmitManual = (e) => {
    const { numero } = props
    e.preventDefault()
    if ((String(numero).length === 11) && !isNaN(numero)) {
      setStepPesadoManual(1)
      props.requestDatosConsultaCeaDestare(numero)
    } else {
      toast.error('Número invalido')
      reset()
    }
  }

  return (
    <div className='campos-cea-destare'>
      <form onSubmit={handleSubmitManual}>
        <CamposPesado0
          label={label}
          validate={validate}
          onBlurInput={onBlurInput}
        />
        <div style={{ visibility: '0', display: 'none' }}>
          <Button
            className='btn-pesado-destare'
            type='submit'
            size='lg'
          >
                        Siguiente
          </Button>
        </div>
      </form>
    </div>
  )
}

const selector = formValueSelector(FORM_PESO_DESTARE)

const mapStateToProps = (state) => ({
  numero: selector(state, 'numero'),
  pesoBruto: selector(state, 'pesoDestare')
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PESO_DESTARE,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(PesadoDestareBalanzaManual))
